import type { AxiosError } from 'axios'

export enum PromoPlanErrorCode {
  PlanAlreadyEnded = 'PlanAlreadyEnded',
}

interface BusinessExceptionFieldError {
  error?: string
  Error?: string
}

interface BusinessExceptionBody {
  message: string
  errorCode?: string
  type: string
  fieldErrors?: BusinessExceptionFieldError[]
}

const getBody = (descriptor: { raw: unknown }): BusinessExceptionBody | undefined =>
  (descriptor.raw as AxiosError<BusinessExceptionBody>)?.response?.data

export const getPromoPlanErrorCode = (descriptor: { raw: unknown }): string | undefined =>
  getBody(descriptor)?.errorCode

/** The per-field messages of a relayed Merchants validation failure; empty when the body carries none. */
export const getPromoPlanFieldErrorMessages = (descriptor: { raw: unknown }): string[] => {
  const fieldErrors = getBody(descriptor)?.fieldErrors
  if (!Array.isArray(fieldErrors)) return []
  return fieldErrors.map(({ error, Error }) => error ?? Error ?? '').filter((message) => message)
}
